module.exports = __webpack_public_path__ + "web/img/speech3.09c1edb2.png";